import {
	lazy,
} from 'react';
import {
	PATHS,
} from '@routes/paths';

// LAZY LOADING
const PageTestApi = lazy(() =>
	import('@layouts/Pages/PageTests/api').then((module) => ({
		default: module.PageTestApi,
	})),
);

export const TEST_ROUTES = [
	{
		element: <PageTestApi />,
		path: PATHS.TESTS.API,
	},
];
